/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-explicit-any */

import { getFileUrl } from "@/lib/get-file-url";
import { useEffect, useState } from "react";
import * as XLSX from "xlsx";
import { Spreadsheet } from "./spreadsheet";
import { AlertCircle, LoaderCircle } from "lucide-react";
import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";

export const ExcelDocViewer = ({ filePath }: any) => {
  const [spreadsheetData, setSpreadsheetData] = useState<
    XLSX.WorkBook | undefined
  >(undefined);

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<any>(undefined);

  const loadDocument = async () => {
    try {
      // const BASE_URL = import.meta.env.VITE_S3_PROXY_TARGET;

      const url = await getFileUrl(filePath);
      // const newUrl = "/s3-proxy" + url.replace(BASE_URL, "");
      // const sampleUrl = "http://localhost:8080/file_example_XLS_10.xls";
      const response = await fetch(url);
      const arrayBuffer = await response.arrayBuffer();
      const workbook = XLSX.read(arrayBuffer, { type: "array" });

      setSpreadsheetData(workbook);
    } catch (error) {
      console.log({ error });
      setError(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    (async () => {
      await loadDocument();
    })();
  }, [filePath]);

  return (
    <div className="pl-2 pt-2 relative h-full">
      {error?.stack ? (
        <Alert variant="destructive">
          <AlertCircle className="h-4 w-4" />
          <AlertTitle>Error</AlertTitle>
          <AlertDescription>Document load failed</AlertDescription>
        </Alert>
      ) : null}
      {loading ? (
        <div
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            background: "rgba(255, 255, 255, 0.8)",
            zIndex: 10,
          }}
        >
          <LoaderCircle className="animate-spin" />
        </div>
      ) : null}
      {spreadsheetData ? (
        <Spreadsheet spreadsheetData={spreadsheetData} />
      ) : null}
    </div>
  );
};

// /* eslint-disable @typescript-eslint/no-explicit-any */

// import { getFileUrl } from "@/lib/get-file-url";
// import { LoaderCircle } from "lucide-react";
// import { useEffect, useState } from "react";

// export const ExcelDocViewer = ({ filePath }: any) => {
//   const [loading, setLoading] = useState(true);
//   const [uiLoading, setUILoading] = useState(true);
//   const [excelUrl, setExcelUrl] = useState<string | undefined>(undefined);

//   useEffect(() => {
//     (async () => {
//       const url = await getFileUrl(filePath);
//       console.log({ url });
//       if (typeof url === "string") {
//         setExcelUrl(url);
//         setTimeout(() => {
//           setUILoading(false);
//         }, 300);
//       }
//     })();
//   }, [filePath]);

//   const path = `https://view.officeapps.live.com/op/embed.aspx?src=http://localhost:8080/file_example_XLS_10.xls`;
//   // const path = `https://view.officeapps.live.com/op/embed.aspx?src=${excelUrl}`;
//   return (
//     <>
//       <img src="http://localhost:8080/file_example_XLS_10.xls" />
//       <iframe
//         src="https://docs.google.com/gview?url=http://localhost:8080/file_example_XLS_10.xls&embedded=true"
//         style={{ width: "100%", height: "700px" }}
//       ></iframe>

//       <iframe
//         src="http://localhost:8080/file_example_XLS_10.xls"
//         width="100%"
//         height="600px"
//       ></iframe>

//       <div style={{ position: "relative", width: "100%", height: "700px" }}>
//         {loading ||
//           (excelUrl && (
//             <div
//               style={{
//                 position: "absolute",
//                 top: 0,
//                 left: 0,
//                 width: "100%",
//                 height: "100%",
//                 display: "flex",
//                 alignItems: "center",
//                 justifyContent: "center",
//                 background: "rgba(255, 255, 255, 0.8)",
//                 zIndex: 10,
//               }}
//             >
//               <LoaderCircle className="animate-spin" />
//             </div>
//           ))}
//         {uiLoading ? null : (
//           <iframe
//             src={path}
//             width="100%"
//             height="700px"
//             onLoad={() => setLoading(false)}
//             style={{ border: "none" }}
//           />
//         )}
//       </div>
//     </>
//   );
// };
